import axios from 'axios';

import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

// Function to set Authorization header
export const setAuthToken = (token) => {
  if (token) {
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`; // แก้ไขที่นี่

  } else {
    delete axiosInstance.defaults.headers.common.Authorization; // แก้ไขที่นี่
  }
};

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];
    const res = await axiosInstance.get(url, { ...config });
    return res.data;
  } catch (error) {
    console.error("Fetching error:", error);
    throw error;
  }
};


// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/auth/me',
    login: '/api/auth/Login',
    register: '/api/register/savelineid',
  },
  user: {
    changeimage: '/api/Upload/uploadimage',
   
  },
  dashboard: {
    list: '/api/HomePage/Home',
    Next: '/api/HomePage/Redirect',
  },
  post: {
    list: '/api/Coupon/GetAllCoupon',
    Save: '/api/Coupon/SaveCoupon',
    MarkasUse: '/api/Coupon/MarkasUseCoupon',
    UsingCoupon: '/api/Coupon/UsingCoupon',
    mycoupon: '/api/Coupon/GetMyCoupon',
    mycouponbyID: '/api/Coupon/GetCouponbyID',
  },

};
